(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-type', {
            parent: 'entity',
            url: '/queue-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-type/queue-types.html',
                    controller: 'QueueTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-type-detail', {
            parent: 'entity',
            url: '/queue-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-type/queue-type-detail.html',
                    controller: 'QueueTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QueueType', function($stateParams, QueueType) {
                    return QueueType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-type-detail.edit', {
            parent: 'queue-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-dialog.html',
                    controller: 'QueueTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueType', function(QueueType) {
                            return QueueType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-type.new', {
            parent: 'queue-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-dialog.html',
                    controller: 'QueueTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-type', null, { reload: 'queue-type' });
                }, function() {
                    $state.go('queue-type');
                });
            }]
        })
        .state('queue-type.edit', {
            parent: 'queue-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-dialog.html',
                    controller: 'QueueTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueType', function(QueueType) {
                            return QueueType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-type', null, { reload: 'queue-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-type.delete', {
            parent: 'queue-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-delete-dialog.html',
                    controller: 'QueueTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QueueType', function(QueueType) {
                            return QueueType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-type', null, { reload: 'queue-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
